<template>
  <div class="pnc-container">
    <template v-if="!isOnPsPromotionsPage">
      <h1 v-if="!accountSummaryFlow">{{ $t('Account.PickAndClaim.Title') }}</h1>
      <loader v-if="showLoader"></loader>
      <div class="available-promos" v-else-if="isAvailabePromExist && !showLoader">
        <div class="available-promos-header" v-html="$t('Account.PickAndClaim.AvailablePromotions')"></div>
        <p class="select-text">{{ $t('Account.PickAndClaim.Select') }}</p>
        <div class="promos"  v-for="(available, key) in groupedAvailableProms" :key="key">
          <div v-if="key !== 'null'" class="grouped-promos">
            <div class="grouped-promos--header">
              <h1>{{ available[0].CampaignName }}</h1>
               <span class="campaign_desription">{{available[0].CampaignExternalDescription}}</span>
            </div>
            <div class="promo-item" v-for="prom in available" :key="prom.IdPromotion">
              <div class="grouped-promos--container">
                <div>
                  <input type="radio" :name="key" :id="prom.IdPromotion" v-model="valuesForRadioFields[prom.IdCampaign]" :value="prom">
                  <label :for="prom.IdPromotion">{{ prom.Description }}</label>
                </div>
                <span @click="expandDetails(prom.IdPromotion)">
                  <span :id="'show_' + prom.IdPromotion" class="visible showDetailsText">{{ $t('Account.PickAndClaim.DetailsText') }}<v-icon>keyboard_arrow_down</v-icon></span>
                  <span :id="'hide_' + prom.IdPromotion" class="hideDetailsText">{{ $t('Account.PickAndClaim.DetailsTextHide') }}<v-icon>keyboard_arrow_up</v-icon></span>
                </span>
                  <!-- <span @click="openDialog(prom, true)">{{ $t('Account.PickAndClaim.DetailsText') }} <v-icon>chevron_right</v-icon></span> -->
              </div>
              <div :id="'note_' + prom.IdPromotion" class="promo_note">{{ prom.Note }}</div> 
            </div>
            <div class="form-actions">
              <v-btn :disabled="Object.keys(valuesForRadioFields[available[0].IdCampaign]).length === 0 ? true : false"  
                @click="claimPromotion(valuesForRadioFields[available[0].IdCampaign].IdPromotion, valuesForRadioFields[available[0].IdCampaign].IdCampaign, valuesForRadioFields[available[0].IdCampaign].IdProvider)" class="success">
                {{ $t('Account.PickAndClaim.Claim') }}
              </v-btn>
            </div>
          </div>
          <div v-else>
            <div v-for="prom in available" :key="prom.IdPromotion" class="standalone-promos">
              <div class="standalone_promo_item">
                <label :for="prom.IdPromotion">{{ prom.Description }}</label>
                <span @click="expandDetails(prom.IdPromotion)">
                  <span :id="'show_' + prom.IdPromotion" class="visible showDetailsText">{{ $t('Account.PickAndClaim.DetailsText') }}<v-icon>keyboard_arrow_down</v-icon></span>
                  <span :id="'hide_' + prom.IdPromotion" class="hideDetailsText">{{ $t('Account.PickAndClaim.DetailsTextHide') }}<v-icon>keyboard_arrow_up</v-icon></span>
                </span>
                <div :id="'note_' + prom.IdPromotion" class="promo_note">{{ prom.Note }}</div>
              </div>

              <v-btn @click="claimPromotion(prom.IdPromotion, prom.IdCampaign, prom.IdProvider)" class="success">{{ $t('Account.PickAndClaim.Claim') }}</v-btn>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="no-available-promos">
        <div class="no-available-promos-header" v-html="$t('Account.PickAndClaim.AvailablePromotions')"></div>
        <p class="no-promos-text">{{ $t('Account.PickAndClaim.NoAvailablePromotions') }}</p>
        <div class="icon-no-available-promos"></div>
      </div>
      <div v-if="isAvailabeClaimedPromExist && !showLoader" class="claimed-promos">
        <div class="claimed-promos-header" v-html="$t('Account.PickAndClaim.Claimed')"></div>
        <p class="claimed-text">{{ $t('Account.PickAndClaim.ClaimedText') }}</p>
        <table>
          <tr>
            <th>{{ $t('Account.PickAndClaim.ColumnPromotions') }}</th>
            <th>{{ $t('Account.PickAndClaim.ColumnCampaign') }}</th>
            <th>{{ $t('Account.PickAndClaim.ColumnStatus') }}</th>
          </tr>
          <tr v-for="claimed in claimedProm" :key="claimed.IdPromotion">
            <td class="claimed-prom-name">{{ claimed.Name }}</td>
            <td>{{ claimed.CampaignName }}</td>
            <td>{{ claimed.Status }}</td>
          </tr>
        </table>
      </div>
    </template>
    <!--Pick and claim on PSPromotion page -->
    <template v-if="isOnPsPromotionsPage">
      <loader v-if="showLoader"></loader>
      <div class="available-promos" v-else-if="isAvailabePromExist && !showLoader">
          <div class="promos"  v-for="(available, key) in groupedAvailableProms" :key="key">
            <div v-if="key !== 'null'" class="grouped-promos">
                <div class="grouped-promos--header">
                  <h2>{{ available[0].CampaignName }}</h2>
                  <span class="campaign_desription">{{available[0].CampaignExternalDescription}}</span>
                </div>
                <div class="grouped-promos--container" v-for="prom in available" :key="prom.IdPromotion">
                  <div>
                    <input type="radio" :name="key" :id="prom.IdPromotion" v-model="valuesForRadioFields[prom.IdCampaign]" :value="prom">
                    <div class="title_and_note">
                      <label :for="prom.IdPromotion">{{ prom.Description }}</label>
                    </div>
                  </div>
                </div>
                <div class="form-actions">
                  <v-btn :disabled="Object.keys(valuesForRadioFields[available[0].IdCampaign]).length === 0 ? true : false"  
                    @click="claimPromotion(valuesForRadioFields[available[0].IdCampaign].IdPromotion, valuesForRadioFields[available[0].IdCampaign].IdCampaign, valuesForRadioFields[available[0].IdCampaign].IdProvider)" class="success">
                    {{ $t('Account.PickAndClaim.Claim') }}
                  </v-btn>
                </div>
            </div>
            <div v-else>
              <div v-for="prom in available" :key="prom.IdPromotion" class="standalone-promos">
                  <v-btn @click="claimPromotion(prom.IdPromotion, prom.IdCampaign, prom.IdProvider)" class="success">{{ $t('Account.PickAndClaim.Claim') }}</v-btn>
              </div>
            </div>
          </div>
      </div>
      <div v-if="isAvailabeClaimedPromExist && !showLoader" class="claimed-promos">
        <div class="claimed-promos-header" v-html="$t('Account.PickAndClaim.ClaimedPsPromotionPage')"></div>
        <span @click="openAccountSection()" class="see_all_claimed_promos">{{ $t('Account.PickAndClaim.ClaimedTextPsPromotionPage') }}<v-icon>chevron_right</v-icon></span>
      </div>
    </template>

    <pick-and-claim-dialog @claimPromotion="claimPromotion" @closeDialog="closePncDialog" v-if="showDetailsDialog.isActive" :dialogDetail="showDetailsDialog"></pick-and-claim-dialog>
  </div>
    
</template>

<script>
import lib from '@/library'
import Loader from '@/components/common/Loader.vue'
import PickAndClaimDialog from './PickAndClaimDialog.vue'

export default {
  components: {
    Loader,
    PickAndClaimDialog
  },
  props: ['isOnPsPromotionsPage', 'promoId', 'campaignId'],
  data () {
    return {
      availabeProm: [],
      claimedProm: [],
      showLoader: false,
      groupedAvailableProms: null,
      valuesForRadioFields: null,
      showDetailsDialog: {
        isActive: false,
        isDetails: false,
        isCampaign: false,
        promotion: null
      }
    }
  },
  computed: {
    isAvailabePromExist () {
      return this.availabeProm.length > 0
    },
    isAvailabeClaimedPromExist () {
      return this.claimedProm.length > 0
    },
    accountSummaryFlow () {
      return window.ctsautoconf.ACCOUNT_SUMMARY_FLOW || false
    }
  },
  methods: {
    openDialog (promotion, details = false, campaign = false) {
      this.showDetailsDialog.isActive = true
      this.showDetailsDialog.isDetails = details
      this.showDetailsDialog.isCampaign = campaign
      this.showDetailsDialog.promotion = promotion
    },
    claimPromotion (IdPromotion, IdCampaign, IdProvider) {
      this.showLoader = true
      const payload = {
        'Promotions': [
          {
            'IdPromotion': IdPromotion,
            'IdCampaign': IdCampaign,
            'IdProvider': IdProvider
          }
        ]
      }
      return new Promise((resolve, reject) => {
        lib.rpcService.callBroker('iw', 'setPcPromotions4Customer', payload)
          .then(response => {
            this.availabeProm = response.result.Response.Available
            this.claimedProm = response.result.Response.Claimed
            if (this.isOnPsPromotionsPage) {
              this.availabeProm = response.result.Response.Available.filter(item => item.IdPromotion === this.promoId || (item.IdCampaign === this.campaignId))
              this.claimedProm = response.result.Response.Claimed.filter(item => item.IdPromotion === this.promoId || (item.IdCampaign === this.campaignId))
            }
            this.formatAvailableProms()
            this.makeValueForRadioFields()
            this.showLoader = false
            this.closePncDialog()
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.showLoader = false
            reject(error)
          })
      })
    },
    closePncDialog () {
      this.showDetailsDialog.isActive = false
      this.showDetailsDialog.isDetails = false
      this.showDetailsDialog.promotion = null
    },
    formatAvailableProms () {
      const result = {}
      for (let prom in this.availabeProm) {
        if (result[this.availabeProm[prom].IdCampaign]) {
          result[this.availabeProm[prom].IdCampaign].push(this.availabeProm[prom])
        } else {
          result[this.availabeProm[prom].IdCampaign] = new Array(this.availabeProm[prom])
        }
      }
      this.groupedAvailableProms = result
    },
    makeValueForRadioFields () {
      const result = {}
      for (let campaign in this.groupedAvailableProms) {
        if (campaign !== 'null') {
          result[campaign] = {}
        }
      }
      this.valuesForRadioFields = result
    },
    fetchAllPcPromotions () {
      this.showLoader = true
      return new Promise((resolve, reject) => {
        lib.rpcService.callBroker('iw', 'getAllPcPromotions4Customer')
          .then(response => {
            this.availabeProm = response.result.Available
            this.claimedProm = response.result.Claimed
            if (this.isOnPsPromotionsPage) {
              this.availabeProm = response.result.Available.filter(item => item.IdPromotion === this.promoId || (item.IdCampaign === this.campaignId))
              this.claimedProm = response.result.Claimed.filter(item => item.IdPromotion === this.promoId || (item.IdCampaign === this.campaignId))
            }
            this.formatAvailableProms()
            this.makeValueForRadioFields()
            this.showLoader = false
            resolve(response)
          }).catch((error) => {
            console.log(error)
            this.showLoader = false
            reject(error)
          })
      })
    },
    openAccountSection () {
      let promotionType = 'pick-and-claim'
      this.$router.replace({
        name: 'promotions',
        query: {
          [promotionType]: true
        }
      }).catch(err => { console.log(err) })
    },
    expandDetails (promoid) {
      let element = document.querySelector("[id='note_" + promoid + "']")
      let showEl = document.querySelector("[id='show_" + promoid + "']")
      let hideEl = document.querySelector("[id='hide_" + promoid + "']")
      if (element.classList.contains('note_visible')) {
        element.classList.remove('note_visible')
        hideEl.classList.remove('visible')
        showEl.classList.add('visible')
      } else {
        element.classList.add('note_visible')
        hideEl.classList.add('visible')
        showEl.classList.remove('visible')
      }
    }
  },
  mounted () {
    this.fetchAllPcPromotions()
  },
  watch: {
    promoId (newVal) {
      if (newVal) {
        this.fetchAllPcPromotions()
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/css/config'
@import '~@/css/mixins'

.pnc-container
  padding 0 10px
  // @media mobile-big-and-below
  //   padding 0 20px
  h1
    // max-width: 400px
    margin: 30px auto
  >>>.spinner
      margin-left: auto
      margin-right: auto
  .claimed-promos
    // max-width: 400px
    margin: 0 auto
    .claimed-promos-header
        border 2px dashed #52b735
        color #52b735
        text-align: center
        font-family 'Open sans Bold'
        padding 5px
    .claimed-text
        padding 10px 5px
        text-align: center
        margin: 0 auto
        font-size: 13px
        line-height normal
    table
      border-bottom: solid 1px #e2e2e2
      .claimed-prom-name
        color #52b735
  .no-available-promos
    margin: 0 auto
    .icon-no-available-promos
      display: block
      background-image: url(icons-path'/'promos_x'.svg')
      height: 80px !important
      width: 80px !important
      margin 15px auto 25px
    .no-available-promos-header
        background: var(--pnc-promos-available-header-bgr)
        padding 10px 
        text-align: center
        color #fff
        font-size 16px
        text-align: left
        display: flex
        align-items: center
        text-align: center
        font-family: 'Open Sans Bold'
        line-height normal
        margin 0 -10px
    .no-promos-text
        max-width: 245px
        padding 20px 5px 5px 5px
        text-align: center
        margin: 0 auto
        font-size: 14px
        @media mobile-big-and-below
          font-size: 14px
  .available-promos
    margin: 0 auto
    .available-promos-header
        margin 0 -10px
        background: var(--pnc-promos-available-header-bgr)
        padding 10px 
        text-align: center
        color #fff
        font-size 16px
        text-align: center
        display: flex
        align-items: center
        text-align: left
        font-family: 'Open Sans Bold'
        line-height normal

    .select-text
        max-width: 245px
        padding 20px 0
        text-align: center
        margin: 0 auto
        font-size: 14px
    .promos
        border-bottom: solid 1px #e2e2e2
        padding-bottom 7px
        margin-bottom: 10px
        .standalone-promos
            display flex
            justify-content: space-between
            align-items: flex-start
            padding 0
            .v-btn
              margin 0
            div
                display flex
                flex-direction: column
                padding-left: 10px
                label
                  font-family 'Open sans Bold'
                  font-weight normal
                  line-height normal
                span
                    font-size 12px
                    display flex
                    align-items center
                    cursor pointer
                    i
                        color var(--pnc-promos-primary-color)
        .grouped-promos
            border 2px dashed var(--pnc-promos-primary-color)
            background-color: transparent
            padding 10px
            .v-btn.success:disabled
              cursor not-allowed
              pointer-events: all !important
            .grouped-promos--container
                display: flex
                justify-content: space-between
                align-items: center
                div
                    display: flex
                    align-items: center
                    justify-content: center
                    margin-bottom 5px
                    input[type="radio"]
                        width 15px
                        height: 15px
                        appearance: none
                        -webkit-appearance: none
                        border: 1px solid var(--pnc-promos-primary-color)
                        background-color: transparent
                        border-radius: 50%;
                        margin-right: 10px
                        box-shadow: 0 0 0 1px var(--pnc-promos-primary-color)
                        cursor pointer
                    input[type="radio"]:checked
                        outline 2px solid var(--pnc-promos-primary-color)
                        background-color: var(--pnc-promos-primary-color)
                        border: 2px solid #fff
                    label
                      font-family 'Open sans Bold'
                      cursor pointer
                      line-height normal
                span
                  font-size 12px
                  display flex
                  align-items center
                  cursor pointer
                  i
                    color var(--pnc-promos-primary-color)
            .grouped-promos--header
                display: flex
                flex-direction: column
                justify-content: center
                align-items: center
                h2
                h4
                  margin 0
                .campaign_desription
                  margin-bottom 20px
                  font-size 13px
                  line-height: normal
                  padding-top: 5px
                span
                  font-size 12px
                  display flex
                  align-items center
                  cursor pointer
                  i
                    color var(--pnc-promos-primary-color)
        .form-actions
            display: flex
            justify-content: center
.title_and_note
  display flex
  align-items flex-start !important
  flex-direction: column
.promo_note
  display none !important
  &.note_visible 
    display flex !important
.hideDetailsText
  display none !important
  &.visible
    display flex !important
.showDetailsText
  display none !important
  &.visible
    display flex !important
.standalone_promo_item
  padding-left 0px !important
.standalone-promos
  .promo_note
    padding-left 0px !important
.grouped-promos
  .promo-item
    padding 7px 0
    .promo_note
      padding-left 25px !important
</style>


// WEBPACK FOOTER //
// src/components/account/PickAndClaim.vue